import React from"react";
import { useNavigate } from"react-router-dom";

export default function LockedPopup({ show, onClose }) {
 const navigate = useNavigate();

 if (!show) return null;

 return (
 <div className="fixed inset-0 bg-bgMain bg-opacity-60 flex items-center justify-center z-50">
 <div className="bg-white p-6 rounded-2xl shadow-lg w-full max-w-md text-center space-y-4">
 <h2 className="text-xl font-bold text-red-600">🔒 Access Restricted</h2>
 <p className="text-gray-700">
 You’ve reached your 2 free page limit for this technology.
 <br />
 Please unlock full access to continue reading.
 </p>
 <div className="flex gap-4 justify-center mt-4">
 <button
 onClick={() => navigate("/skillgenpayments")}
 className="bg-secondary hover:bg-primary text-white font-semibold px-4 py-2 rounded-lg"
 >
 🔓 Upgrade to Premium
 </button>
 <button
 onClick={onClose}
 className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-medium px-4 py-2 rounded-lg"
 >
 Cancel
 </button>
 </div>
 </div>
 </div>
 );
}



